// extracted by mini-css-extract-plugin
module.exports = {"dividedContent":"DividedContent_dividedContent__2VmaO","divider":"DividedContent_divider__18n7l","title":"DividedContent_title__oc4L3","content":"DividedContent_content__1eksw"};